import {
  ScheduleConsultType,
  ScheduleTimeAvailableData,
} from "../../core/http/service/SchedulingService";
import {
  ScheduleDay,
  ScheduleTime,
} from "../../core/http/service/SchedulingService";

export const RESET_SELECTED_TIME_AVAILABLE = "RESET_SELECTED_TIME_AVAILABLE";
export const SET_SELECTED_TIME_AVAILABLE = "SET_SELECTED_TIME_AVAILABLE";
export const SET_SCHEDULING_PATIENT = "SET_SCHEDULING_PATIENT";
export const SET_SCHEDULE_CONSULT_TYPE = "SET_SCHEDULE_CONSULT_TYPE";
export const GET_SELECTED_TIME_AVAILABLE = "GET_SELECTED_TIME_AVAILABLE";

const sendToAnalytics = (action = "", error: any = null) => {
  console.error(action, error);
};

export const setSchedulingPatient = (pacienteId: string, empresaId: string) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: SET_SCHEDULING_PATIENT,
        pacienteId,
        empresaId,
      });
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const setScheduleConsultType = (consultType: ScheduleConsultType) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: SET_SCHEDULE_CONSULT_TYPE,
        consultType,
      });
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const setSelectedTimeAvailable = (
  selectedTimeAvailable: ScheduleTimeAvailableData,
  selectedScheduleDay: ScheduleDay,
  selectedScheduleHour: ScheduleTime,
  pacienteId?: string,
  empresaId?: string
) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: SET_SELECTED_TIME_AVAILABLE,
        selectedTimeAvailable,
        selectedScheduleDay,
        selectedScheduleHour,
        modalOpen: true,
        pacienteId,
        empresaId,
      });
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const resetSelectedTimeAvailable = () => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: RESET_SELECTED_TIME_AVAILABLE,
        selectedTimeAvailable: undefined,
        selectedScheduleHour: undefined,
        selectedScheduleDay: undefined,
        modalOpen: false,
      });
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};
